import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const ROW_LABEL_WIDTH = 220;

// Shared label/value row used by the review-confirm modal "record details" cards.
export const DetailRow = ({ label, children }: { label: string; children: React.ReactNode }) => (
  <Stack
    direction="row"
    spacing={1}
    alignItems="center"
    sx={{ py: 0.5, width: '100%', borderBottom: '1px solid', borderColor: 'divider', '&:last-of-type': { border: 0 } }}
  >
    <Typography
      component="span"
      variant="subtitle2"
      color="text.secondary"
      sx={{ width: ROW_LABEL_WIDTH, flexShrink: 0 }}
    >
      {label}
    </Typography>
    <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
  </Stack>
);
